import { render, staticRenderFns } from "./MitLandingPage.vue?vue&type=template&id=7989ce4e&scoped=true"
import script from "./MitLandingPage.vue?vue&type=script&lang=js"
export * from "./MitLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7989ce4e",
  null
  
)

export default component.exports